import { render, staticRenderFns } from "./MyClientDetail.vue?vue&type=template&id=1fcf2a95&scoped=true&"
import script from "./MyClientDetail.vue?vue&type=script&lang=js&"
export * from "./MyClientDetail.vue?vue&type=script&lang=js&"
import style0 from "./MyClientDetail.vue?vue&type=style&index=0&id=1fcf2a95&prod&scoped=true&lang=css&"
import style1 from "./MyClientDetail.vue?vue&type=style&index=1&id=1fcf2a95&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcf2a95",
  null
  
)

export default component.exports